import React from 'react'
import { Course } from './types'
import moment from 'moment'
import { FlexRow } from '../FlexboxReusables/FlexItems'
import { CheckCircle } from 'react-feather'
import { Typography } from 'antd'
import { FormattedMessage } from 'react-intl'

type CourseAlreayPublishedProps = {
  course: Course
}

export const CourseAlreadyPublished: React.FC<CourseAlreayPublishedProps> = ({ course }) => {
  const dateDay = moment.utc(course.publishedAt).local().format('DD.MM.YYYY')
  const dateHour = moment.utc(course.publishedAt).local().format('HH:mm')

  return (
    <FlexRow justifyContent='center' height='3em'>
      <CheckCircle size={18} color='green' />
      <Typography.Title level={5} style={{margin: '0 0 0 0.5em'}}>
        <FormattedMessage id="editor.courseWasAlreadyPublished" values={{dateDay, dateHour }} />
      </Typography.Title>
    </FlexRow>
  )
}

export default CourseAlreadyPublished